/*
 * Module for the list control
*/
rs.module("controls/list",

    ["controls/components/delete-prompt", "controls/components/event-banner"],

    function (deletePrompt, eventBanner) {

        //
        // Initialize
        //
        function initialize(jsSelectors, cssClasses, hasActions, hasDetail, listApisToShareDetailWith, showDetailOnLoad, context) {

            var _onItemClickCallback;
            var _onItemDeletedCallback;
            var _onItemDownloadStartedCallback;
            var _onItemDownloadCompletedCallback;
            var detailApi;

            var listItems = $.js(jsSelectors.listItem, { required: false, multiple: true });
            var listItemContainers = $.js(jsSelectors.listItemContainer, { required: false, multiple: true });

            if (hasDetail) {
                detailApi = rs.module("controls/list/detail").initialize(jsSelectors, cssClasses, showDetailOnLoad, () => exports);

                // If we have APIs we are sharing detail with, hook them up to our detail
                listApisToShareDetailWith.forEach((api) => {
                    api.detail = detailApi;
                    api.detail.attachEvents(api.items());
                });
            }

            var touchInProgress = false;
            var touchMovementDetected = false;
            var touchStartX;
            var touchStartY;

            // Listen for click events on non disabled list items
            listItems.filter(`:not(.${cssClasses.disabled})`).on("click enterpressed", function (event) {

                // If a touch is in progress, prevent the default click since the user may also be swiping.
                // We will trigger the click manually later (see touchend event) if no swipe occurred.
                if (touchInProgress) {
                    return false;
                }

                // Toggle highlight from previously selected list item to the newly selected list item
                listItems.removeClass(cssClasses.selected);
                $(this).addClass(cssClasses.selected);

                // if this is a link that is redirecting to another page, show the loading spinner (note: this will only show on mobile)
                $(this).has(".redirect-link.loading-spinner").addClass(cssClasses.executing);

                // If item click callback has been defined execute it
                if (_onItemClickCallback) {
                    _onItemClickCallback.call(this, event, _getItemContext($(this)));
                }
            });

            // initialize actions for list item
            if (hasActions) {

                // Handle swiped-left event
                listItems.on("swiped-left", function (event) {
                    if ($.isMobile()) {
                        var listItemContainer = $(this).closest(`[data-js=${jsSelectors.listItemContainer}]`);
                        listItemContainers.not(listItemContainer).removeClass(cssClasses.swiped);
                        listItemContainer.addClass(cssClasses.swiped);
                    }
                });

                // Handle swiped-right event
                listItems.on("swiped-right", function (event) {
                    listItemContainers.removeClass(cssClasses.swiped);
                });

                // Handle touchstart event
                listItems.on("touchstart", function (event) {

                    // Indicate that a touch is in progress, which will prevent the default click since the user may also be swiping.
                    // We will trigger the click manually later (see touchend event) if no swipe occurred.
                    touchInProgress = true;

                    // record touch start position
                    touchStartX = event.touches[0].clientX;
                    touchStartY = event.touches[0].clientY;
                });

                // Handle touchmove event
                listItems.on("touchmove", function (event) {

                    // This event will be fired repeatedly as the user swipes their finger.
                    // Once we've detected movement (a swipe), we no longer need to calculate this
                    if (touchMovementDetected) {
                        return;
                    }

                    // compare touch start position with end postion to calculate movement distance
                    var touchEndX = event.changedTouches[0].clientX;
                    var touchEndY = event.changedTouches[0].clientY;
                    var touchDiffX = touchStartX - touchEndX;
                    var touchDiffY = touchStartY - touchEndY;

                    // detect touch movement over 20px (20px is consistent with the threshold for triggering swipes)
                    touchMovementDetected = (Math.abs(touchDiffX) > 20) || (Math.abs(touchDiffY) > 20);
                });

                // Debounce touchend to prevent double firing in rare instances that the device registered a double touch from a single touch
                listItems.on("touchend", _.debounce(onTouchEnd, 200));

                // Handle touchend event
                function onTouchEnd(event) {

                    // Reset to false since the touch has ended. 
                    // We need to reset this here since the subsequent code may trigger a click.
                    touchInProgress = false;

                    // If no touch movement was detected...
                    if (!touchMovementDetected) {
                                    
                        // If an item in the list is currently swiped open, then remove swipe class to close it
                        if (listItemContainers.hasClass(cssClasses.swiped)) {
                            listItemContainers.removeClass(cssClasses.swiped);
                        }
                        // Else, trigger click 
                        else {
                            $(this).click();
                        }                     
                    }

                    // Reset to false since the touch has ended. 
                    touchMovementDetected = false;
                }

                deletePrompt.onDeleteInitiated(function (deleteElement, deletePrompt) {
                    deletePrompt.destroy();
                    $(deleteElement).addClass(cssClasses.executing);
                });

                deletePrompt.onDeleteSuccess(function (deleteElement, deletePrompt) {
                    //hide the list item
                    $(deleteElement).closest(`[data-js=${jsSelectors.listItemContainer}]`).addClass("_deleted").slideUp(400, function () {
                        // slide up animation complete

                        // get the context for the deleted item before we remove it
                        let itemContext = _getItemContext($(this));

                        // remove item
                        $(deleteElement).closest(`[data-js=${jsSelectors.listItemContainer}]`).remove();

                        // Show empty text after item is deleted if it was the last one
                        var noItemsRemaining = $.js(jsSelectors.listItem, { required: false, multiple: true }).length == 0;
                        $.js(jsSelectors.emptyText).toggle(noItemsRemaining)

                        // If item deleted callback has been defined execute it
                        if (_onItemDeletedCallback) {
                            _onItemDeletedCallback.call(null, itemContext);
                        }
                    });
                });

                deletePrompt.onDeleteFailure(function (deleteElement, deletePrompt, error) {
                    $(deleteElement).removeClass(cssClasses.executing);
                    $(deleteElement).closest(`[data-js=${jsSelectors.listItemContainer}]`).removeClass(cssClasses.swiped);
                    eventBanner.addErrorMessages("Delete failed.");
                });
            }

            // helper function to get context for a list item - if any was defined on the list control
            function _getItemContext(item) {
                return context[item.data("contextkey")];
            }

            //
            // API function to allow consumers to get the collection of items in the list
            //
            function items() {
                return $.js(jsSelectors.listItem, { required: false, multiple: true });
            }

            // Reloads the current item
            function reload() {
                var selectedItem = $.js(jsSelectors.listItem, { required: false, multiple: true }).filter(`.${cssClasses.selected}`);
                var context = _getItemContext(selectedItem);

                if (_onItemClickCallback) {
                    _onItemClickCallback.call(this, null, context);
                }
            }

            //
            // API function to allow consumers to get the selected item and its context from the list
            //
            function selectedItem() {
                var selectedItem = $.js(jsSelectors.listItem, { required: false, multiple: true }).filter(`.${cssClasses.selected}`);

                if (selectedItem.length == 0) {
                    return null;
                }

                return {
                    item: selectedItem,
                    context: _getItemContext(selectedItem)
                }
            }

            //
            // API function to allow consumers to provide a call back function to execute awhen a list item is clicked
            //
            function onItemClick(onItemClickCallback) {
                _onItemClickCallback = onItemClickCallback;
            }

            //
            // API function to allow consumers to provide a call back function to execute after a successful delete of a list item
            //
            function onItemDeleted(onItemDeletedCallback) {
                _onItemDeletedCallback = onItemDeletedCallback;
            }

            //
            // API function to allow consumers to provide a callback function to execute when a download link has been clicked 
            //
            function onItemDownloadStarted(onItemDownloadStartedCallback) {
                _onItemDownloadStartedCallback = onItemDownloadStartedCallback;
            };

            //
            // API function to allow consumers to provide a callback function to execute when a download link download has completed
            //
            function onItemDownloadCompleted(onItemDownloadCompletedCallback) {
                _onItemDownloadCompletedCallback = onItemDownloadCompletedCallback;
            };

            /// Callback for download links, to retrieve the download options
            function onGetDownloadOptions(element) {
                // if the element itself is a list item, use it. otherwise find the closest parent list item (to support download links inside of templated list items)
                var listItem = null;
                if ($(element).is(`[data-js~='${jsSelectors.listItem}']`)) {
                    listItem = element;
                }
                else {
                    var nearestListItem = $(element).closest(`[data-js~='${jsSelectors.listItem}']`);
                    if (nearestListItem.length) {
                        listItem = nearestListItem[0];
                    }
                }

                return {
                    onstart: function () {
                        $(listItem).addClass(cssClasses.executing);

                        if (_onItemDownloadStartedCallback) {
                            _onItemDownloadStartedCallback.call(this, $(listItem), _getItemContext($(listItem)));
                        }
                    },
                    oncomplete: function (status) {
                        $(listItem).removeClass(cssClasses.executing);

                        if (_onItemDownloadCompletedCallback) {
                            _onItemDownloadCompletedCallback.call(this, $(listItem), _getItemContext($(listItem)));
                        }
                    }
                };
            }

            //
            // API function to allow consumers to unselect all items
            //
            function unSelectItems() {
                items().removeClass(cssClasses.selected);
            }

            // Exported instance API
            var exports = {
                items,
                selectedItem,
                onItemClick,
                onItemDeleted,
                onItemDownloadStarted,
                onItemDownloadCompleted,
                onGetDownloadOptions,
                reload,
                unSelectItems,
                detail: detailApi ?? {
                    loadDetail: function () {
                        console.error("Detail has not been defined on the list control.")
                    }
                }
            };

            return exports;
        }

        // Exported public API
        var exports = {
            initialize
        };

        return exports;
    }
);